import type { PZItem, ProductVariant } from '../../types/pz';
import { getProductSelectionLabel } from '../../utils/productSelectorLabel';

type PZVariantLine = Partial<PZItem>;

export function buildPZVariantAutofill(
  line: PZVariantLine,
  variantId: string | undefined,
  variant: ProductVariant | undefined,
  canEditPurchasePrices: boolean,
): PZVariantLine {
  if (!variantId || !variant) {
    return { productVariantId: undefined };
  }

  const patch: PZVariantLine = {
    productVariantId: variantId,
    productName: getProductSelectionLabel(variant, variant.variantName),
    productCode: variant.product?.code || '',
    sku: variant.sku,
    // Selector variants expose effective inherited/overridden values. Prefer
    // those over the physical Product defaults.
    ean: variant.ean ?? variant.product?.ean ?? '',
    unit: variant.product?.baseUnit || 'PIECE',
    netWeight: variant.netWeight ?? variant.product?.netWeight,
    grossWeight: variant.grossWeight ?? variant.product?.grossWeight,
    width: variant.product?.width ?? variant.width ?? null,
    height: variant.product?.height ?? variant.height ?? null,
    length: variant.product?.length ?? variant.length ?? null,
    thickness: variant.product?.thickness ?? variant.thickness ?? null,
    productCategoryName: variant.product?.productCategoryName ?? null,
    productCategoryColor: variant.product?.productCategoryColor ?? null,
    productCategoryDimensionDisplayProfile:
      variant.product?.productCategoryDimensionDisplayProfile ?? null,
  };

  if (canEditPurchasePrices && variant.defaultPurchasePrice != null) {
    patch.unitPrice = Number(variant.defaultPurchasePrice);
    patch.currency = variant.defaultPurchaseCurrency || line.currency || 'PLN';
    patch.totalPrice = Number(line.quantityOrdered || 0) * patch.unitPrice;
  }

  return patch;
}
